import { SetState, GetState } from 'zustand';

export interface ITransactionsCategoriesSlice {
  categoriesList: any;
  setCategoriesList: (categoriesList:any) => void;
  getCategoriesList: () => any;
}

const createTransactionsCategoriesSlice = (set: SetState<ITransactionsCategoriesSlice>, get: GetState<ITransactionsCategoriesSlice>) => ({
  categoriesList: [],
  setCategoriesList: (categoriesList: any) => {
    set({
      categoriesList,
    });
  },
  getCategoriesList: () => get().categoriesList,
});

export default createTransactionsCategoriesSlice;
